import { useMutation, useQueryClient } from '@tanstack/react-query';

import { patchDemandDefinition } from '../../common/api/clients/demandDefinitions.api';
import type { PatchDemandDefinitionRequest } from '../../common/api/clients/demandDefinitions.api';
import { queries } from '../../common/api/queryKeys/queries';

interface PatchDemandDefinitionMutation {
    definitionId: string;
    request: PatchDemandDefinitionRequest;
}

export const usePatchDemandDefinition = (customerGroupId?: string) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ definitionId, request }: PatchDemandDefinitionMutation) =>
            patchDemandDefinition({ id: definitionId, request, customerGroupId }),
        onSuccess: (definition) => {
            queryClient.setQueryData(queries.demandDefinitions.detail(definition.id).queryKey, definition);

            return Promise.all([
                queryClient.invalidateQueries({ queryKey: queries.demandDefinitions.list._def }),
                queryClient.invalidateQueries({ queryKey: queries.demandDefinitions.calculation._def }),
                queryClient.invalidateQueries({ queryKey: queries.demandDefinitions.fleet._def }),
            ]);
        },
    });
};
